/* eslint-disable vue/require-v-for-key */
/* eslint-disable vue/require-default-prop */
 <template>
  <div>
    <b-form>
      <div class="row">
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Cósigo Siagro:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="unidade.cod_siagro"
              type="number"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Tipo Físico:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="unidade.tipo_fisico"
              type="text"
              placeholder="Tipo Físico"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Unidade 1:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="unidade.unid1"
              type="text"
              placeholder="Unidade 1"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Unidade 2:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="unidade.unid2"
              type="text"
              placeholder="Unidade 2"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Unidade SL:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="unidade.unidade_sl"
              type="text"
              placeholder="Unidade SL"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Fator Conversão:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="unidade.fator_conversao"
              type="text"
              placeholder="Fator de conversão"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group id="input-group-1" label="Fórmula:" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="unidade.formula"
              type="text"
              placeholder="Fórmula"
              required
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-1"
            label="Código SIGA:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="unidade.cod_siga"
              type="text"
              placeholder="SIGA"
              required
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <b-button type="submit" variant="success" @click.prevent="salvarUnidade"
        >Salvar</b-button
      >
    </b-form>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </div>
</template>
<script>
import Unidade from '@src/services/unidade'
import { mask } from 'vue-the-mask'
import Loading from 'vue-loading-overlay'

export default {
  components: {
    Loading,
  },
  directives: { mask },
  props: {
    unidade: {},
  },
  data() {
    return {
      modal: {
        show: false,
        mensagems: null,
        sucesso: null,
      },
      isLoading: false,
    }
  },
  created() {},
  mounted() {},
  methods: {
    loading(a) {
      a = !this.isLoading
      return a
    },
    modalShow() {
      if (this.modal.show === true) {
        this.modal.show = false
      }
    },
    salvarUnidade() {
      const token = this.$store.state.auth.currentUser.token
      if (this.unidade.id_unidade) {
        this.isLoading = this.loading(this.isLoading)
        Unidade.update(token, this.unidade)
          .then((resposta) => {
            this.modal.show = true
            this.$bvToast.toast('Atualizado com sucesso', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.modal.mensagems = resposta.data.aviso
            this.isLoading = this.loading(this.isLoading)
          })
          .catch((erro) => {
            this.$bvToast.toast(erro.response.data.data.join(', '), {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.isLoading = this.loading(false)
          })
      } else {
        this.isLoading = this.loading(this.isLoading)
        Unidade.salvar(token, this.unidade)
          .then((resposta) => {
            this.isLoading = this.loading(this.isLoading)
            if (!resposta.data.sucesso) {
              this.$bvToast.toast(resposta.data.mensagem, {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            } else {
              this.$bvToast.toast('Salvo com sucesso!', {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            }
            this.unidade = {}
          })
          .catch((erro) => {
            console.log(erro)
            this.isLoading = this.loading(this.isLoading)
            this.$bvToast.toast(
              erro.response
                ? erro.response.data.data.join(', ')
                : 'Erro inesperado',
              {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
            this.isLoading = this.loading(false)
          })
      }
    },
  },
}
</script>

<style>
</style>